import { Link } from 'react-router-dom';
import { contentList } from '@/mocks/content';

export default function FeaturedContent() {
  const featured = contentList.filter((item) => item.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门中文字幕日韩剧推荐
            </h2>
            <p className="text-foreground-600 text-sm">精选高分日韩剧、电影，均带优质中文字幕</p>
          </div>
          <Link
            to="/category/jdrama"
            className="whitespace-nowrap hidden sm:flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {featured.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:bg-background-200/30 cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} 中文字幕日韩剧推荐`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-950/70 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {item.categoryLabel}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {item.description}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  {item.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-500 ml-auto whitespace-nowrap">
                    {item.subtitleStatus}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}